import React from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import { useLocation } from '@reach/router';
import Box from '@material-ui/core/Box';
import Pagination from '@material-ui/lab/Pagination';
import usePageLimit from '../usePageLimit';

export const reduceActivePageNumber = (num) =>
  !num || num < 1 ? 0 : num - 1;

export const usePageChange = () => {
  const { pathname, search } = useLocation();

  return (num) => {
    const replace = () => {
      const v = reduceActivePageNumber(num);

      if (!search || search === '?') return `?page=${v}`;
      if (!search.includes('page'))
        return `${search}&page=${v}`;

      return search.replace(
        /page=[^&$]*/i,
        `page=${reduceActivePageNumber(num)}`,
      );
    };

    return navigate(pathname + replace(search, num));
  };
};

const ProductPagination = ({ total }) => {
  const { search } = useLocation();
  const change = usePageChange();
  const count = Math.ceil(total / usePageLimit().limit);

  const getSearchValue = () => {
    try {
      const match = search.match(
        /(?:\/page\/|[?&]page=)([0-9]\d*)/,
      );

      if (match) {
        return Number(match[1]) + 1;
      }

      return 1;
    } catch (e) {
      return 1;
    }
  };

  const page = getSearchValue();

  React.useEffect(() => {
    if (page > count) change(0);
  }, [page, count]);

  return (
    <Box
      my={6}
      mx="auto"
      display="inline-block"
      align="center"
    >
      <Pagination
        color="primary"
        count={count}
        onChange={(e, num) => change(num)}
        page={page}
      />
    </Box>
  );
};

ProductPagination.defaultProps = {
  total: 0,
};

ProductPagination.propTypes = {
  total: PropTypes.number,
};

export default ProductPagination;
